// extracted by mini-css-extract-plugin
module.exports = {"DefaultTheme__menu___rxQog":"DefaultTheme__menu___rxQog","DefaultTheme__title-container___2VHVJ":"DefaultTheme__title-container___2VHVJ"};